import replace from 'lodash/replace';
import colors from '~/theme/colors.module.scss';

export interface HighlightTextProps {
  textToHighlight: string | RegExp;
  text: string;
}

const HighlightText: React.FC<HighlightTextProps> = ({ text, textToHighlight }) => {
  if (!textToHighlight) return <>{text}</>;

  const styles = `background-color: ${colors.colorLemon500}`;

  const newValue = replace(text, textToHighlight, (str) => `<span style="${styles}">${str}</span>`);
  return <span dangerouslySetInnerHTML={{ __html: newValue }} />;
};

export default HighlightText;
